
import { openReactActionDialog } from '~commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { Messages } from '~src/codegen/Localize';
import { EditDataConnectPoolDialogBody, EditDataConnectPoolDialogProps, EditDataConnectPoolDialogState } from '~src/settings/dataconnect-settings/sections/dataConnectMultiPool/EditDataConnectPoolDialog';
import { IUpdateBaasEdgePoolParams, IUpdateBaasEdgePoolResult } from '~src/settings/dataconnect-settings/serverApi/requests/UpdateBaasEdgePoolRequest';
import { BaasEdgePoolAndCluster } from '~src/settings/dataconnect-settings/serverApi/resources/BaasEdgePoolAndCluster';

import { ActionItemInfo } from '../MoreActionsMenu';
import { getGeneralErrorMessage } from '../utils/EdgePoolErrorUtilities';

export function openEditPoolDialog(actionItem: ActionItemInfo, refreshEdgePools: () => void) {
  const action = (_: EditDataConnectPoolDialogProps, state: EditDataConnectPoolDialogState) => {
    const updateProps: IUpdateBaasEdgePoolParams = {
      poolId: actionItem.poolId,
      displayName: state.poolName,
      domainChange: null,
      DataConnectSettingsVersion: '0'
    };

    return BaasEdgePoolAndCluster.updateBaasPool(updateProps)
      .then((result: IUpdateBaasEdgePoolResult) => {
        refreshEdgePools();
        if(result.success) {
          ToasterService.instance.pop({ type: ToastType.Success, text: Messages.dataConnectSiteSettingsEditPoolSuccess() });
        }
        if(result.errors) {
          ToasterService.instance.pop({
            type: ToastType.Error,
            text: getGeneralErrorMessage(result.errors[0].code, result.errors[0].message)
          });
        }
        return Promise.resolve({});
      });
  };

  const dialogInstance = openReactActionDialog({
    title: Messages.dataConnectSiteSettingsEditPool(),
    bodyComponent: EditDataConnectPoolDialogBody,
    initialBodyProps: { existingPoolNames: actionItem.existingPoolNames },
    initialDialogState: { poolName: actionItem.poolName, hasError: false },
    actionName: Messages.save(),
    action: action,
    actionDisabled: (_, state: EditDataConnectPoolDialogState) => state.poolName.length === 0 || state.hasError,
    dismissDialogOnActionFailed: true,
    dialogWidth: TabDialogWidth.width375px,
  });

  return Promise.resolve(dialogInstance.result);
}
